// extracted by mini-css-extract-plugin
export var active = "_is-2";
export var recordingDot = "_is-1";
export var recordingIndicator = "_is-0";